var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33329 14C8.81244 13.9997 10.249 13.5045 11.4141 12.5934L15.0775 16.2567L16.2558 15.0784L12.5925 11.415C13.5041 10.2497 13.9996 8.81288 14 7.33335C14 3.65752 11.0091 0.666687 7.33329 0.666687C3.65746 0.666687 0.666626 3.65752 0.666626 7.33335C0.666626 11.0092 3.65746 14 7.33329 14ZM7.33329 2.33335C10.0908 2.33335 12.3333 4.57585 12.3333 7.33335C12.3333 10.0909 10.0908 12.3334 7.33329 12.3334C4.57579 12.3334 2.33329 10.0909 2.33329 7.33335C2.33329 4.57585 4.57579 2.33335 7.33329 2.33335Z",
    fill: "#062324",
    fillOpacity: 0.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4c1efdc40153b7096c2ab1c9c14ebb33.svg";
export { ForwardRef as ReactComponent };